import type {StaffRole} from '@pocketbuy/outdoor-business-types';
import type {RegionOptions} from './api';

export type SalesHierarchy = {salesRegionIds:number[];businessReporting:Record<string,number>};
export const isBusinessManager=(roles:StaffRole[])=>roles.some(r=>r==='BUSINESS_MANAGER'||r==='BUSINESS_EXECUTIVE');
export function hierarchyComplete(roles:StaffRole[],value:SalesHierarchy,options:RegionOptions) {
  if(roles.includes('SYSTEM_ADMIN'))return true;
  if(roles.includes('DEPUTY_REGIONAL_MANAGER')&&(!value.salesRegionIds.length||value.salesRegionIds.some(id=>!options.regions.some(r=>r.id===id))))return false;
  if(isBusinessManager(roles)&&(!Object.keys(value.businessReporting).length||Object.entries(value.businessReporting).some(([region,leader])=>!options.regions.some(r=>r.id===Number(region))||!options.leaders.some(p=>p.id===leader&&p.regionIds?.includes(Number(region))))))return false;
  return true;
}


export type ClusterParent={regionId:string;managerUserId:string};
export function clusterParentComplete(value:ClusterParent,options:RegionOptions) {
 return options.regions.some(r=>String(r.id)===value.regionId)&&options.businessManagers.some(p=>String(p.id)===value.managerUserId&&Boolean(p.reporting?.[value.regionId]));
}
